export default "__VITE_ASSET__CmY$vq8b__"